export var ENTER_KEY_CODE = 13;
export var ESC_KEY_CODE = 27;